module.exports = __webpack_public_path__ + "img/2016.12d25942.jpg";